import { render, staticRenderFns } from "./SimcardStatusChart.vue?vue&type=template&id=4b18f8e6&scoped=true"
import script from "./SimcardStatusChart.vue?vue&type=script&lang=js"
export * from "./SimcardStatusChart.vue?vue&type=script&lang=js"
import style0 from "./SimcardStatusChart.vue?vue&type=style&index=0&id=4b18f8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18f8e6",
  null
  
)

export default component.exports